import { createWebHistory, createRouter } from 'vue-router'

import BffHomeView from '../views/BffHomeView.vue'
import BffMapView from '../views/BffMapView.vue'
import BffEventsView from '../views/BffEventsView.vue'
import BffShopView from '../views/BffShopView.vue'
import BffNewsView from '../views/BffNewsView.vue'
import BffDataView from '../views/BffDataView.vue'
import BffFaqView from '../views/BffFaqView.vue'

const routes = [
  { 
    path: '/',
    name: 'home',
    component: BffHomeView
    // meta: {
    //   layout: 'default'
    // }
  },
  { 
    path: '/map',
    name: 'map',
    component: BffMapView
  },
  { 
    path: '/events',
    name: 'events',
    component: BffEventsView
  },
  { 
    path: '/shop',
    name: 'shop',
    component: BffShopView
  },
  { 
    path: '/news',
    name: 'news',
    component: BffNewsView
  },
  { 
    path: '/sighting-analysis',
    name: 'sighting-analysis',
    component: BffDataView
  },
  { 
    path: '/faq',
    name: 'faq',
    component: BffFaqView
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: AboutView,
  //   children: [
  //     {
  //       path: '/123',
  //       name: 'aboutchild',
  //       component: AboutViewChild
  //     }
  //   ]
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router